<section id="experience-section" class=" py-36 px-4">
  <div class="container relative text-gray-800">
    <h2 class="text-3xl font-extrabold mb-20 text-center capitalize">
      Mon <span class="text-blue-800"> experience</span>
    </h2>
    <div
      class="grid grid-cols-1 gap-1 justify-center place-items-stretch lg:px-20 md:px-0"
    >
      <div class="mb-4">
        <h3 class="text-center text-2xl mb-2">Ma carrière</h3>
        <div
          class="grid grid-cols-1 bg-white border-l-4 border-blue-800 rounded-md"
        >
          <div class="border-b border-gray-300 p-6">
            <span class="text-blue-800 font-bold"
              >Developpeur Full Stack chez IntegraGen</span
            >
            <p class="text-gray-600 mb-2">janvier 2022 - aujourd'hui à Evry</p>
            <p>Réalisations :</p>
            <ul class="list-disc list-inside">
              <li class="pb-1">
                Mise en place d'une application interne de traçabilité des
                échantillons entrant dans les laboratoires de la boite.
              </li>
              <li class="pb-1">
                Mise en place de divers applications interne de gestions de
                stock, gestions des projets.
              </li>
              <li class="pb-1">
                Maintient de divers applications concernant la gestion RH.
              </li>
            </ul>
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-blue-100 bg-blue-600 rounded-full"
              >Symfony 2.7 - 5.1</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-blue-100 bg-blue-600 rounded-full"
              >Python 3.9</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-blue-100 bg-blue-600 rounded-full"
              >MySql</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-green-100 bg-green-600 rounded-full"
              >HTML</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-green-100 bg-green-600 rounded-full"
              >CSS</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-green-100 bg-green-600 rounded-full"
              >jQuery</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-gray-100 bg-gray-900 rounded-full"
              >Google Cloud</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-gray-100 bg-gray-900 rounded-full"
              >SalesForce</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-gray-100 bg-gray-900 rounded-full"
              >Github</span
            >
          </div>
          <div class="border-b border-gray-300 p-6">
            <span class="text-blue-800 font-bold"
              >Developpeur Full Stack chez Carjager</span
            >
            <p class="text-gray-600 mb-2">
              juin 2021 - décembre 2021 en télétravail 100%
            </p>
            <p>Réalisations :</p>
            <ul class="list-disc list-inside">
              <li class="pb-1">
                Mise en place de nouveaux modules au sein du site Carjager
              </li>
              <li class="pb-1">Intégration de maquette</li>
              <li class="pb-1">Correctif de bugs</li>
            </ul>
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-blue-100 bg-blue-600 rounded-full"
              >Symfony 4.4</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-blue-100 bg-blue-600 rounded-full"
              >PostgreSQL</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-green-100 bg-green-600 rounded-full"
              >HTML5</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-green-100 bg-green-600 rounded-full"
              >React</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-green-100 bg-green-600 rounded-full"
              >NextJS</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-green-100 bg-green-600 rounded-full"
              >SASS</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-gray-100 bg-gray-900 rounded-full"
              >Algolia</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-gray-100 bg-gray-900 rounded-full"
              >Github</span
            >
          </div>
          <div class="p-6">
            <span class="text-blue-800 font-bold"
              >Developpeur Full Stack chez IntegraGen</span
            >
            <p class="text-gray-600 mb-2">2014 - 2021 à Evry</p>
            <p>Réalisations :</p>
            <ul class="list-disc list-inside">
              <li class="pb-1">
                Mise en place d'une application interne de traçabilité des
                échantillons entrant dans les laboratoires de la boite.
              </li>
              <li class="pb-1">
                Mise en place de divers applications interne de gestions de
                stock, gestions des projets.
              </li>
              <li class="pb-1">
                Maintient de divers applications concernant la gestion RH.
              </li>
            </ul>
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-blue-100 bg-blue-600 rounded-full"
              >Symfony 2.7 - 5.1</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-blue-100 bg-blue-600 rounded-full"
              >MySql</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-green-100 bg-green-600 rounded-full"
              >HTML</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-green-100 bg-green-600 rounded-full"
              >CSS</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-green-100 bg-green-600 rounded-full"
              >jQuery</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-gray-100 bg-gray-900 rounded-full"
              >Google Cloud</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-gray-100 bg-gray-900 rounded-full"
              >SalesForce</span
            >
            <span
              class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-gray-100 bg-gray-900 rounded-full"
              >Github</span
            >
          </div>
        </div>
      </div>
      <div>
        <h3 class="text-center text-2xl mb-2">Mes formations</h3>
        <div
          class="grid grid-cols-1 mx-2 bg-white border-l-4 border-blue-800 rounded-md"
        >
          <div class="border-b border-gray-300 p-6">
            <span class="text-blue-800 font-bold"
              >Licence pro. Projet web & Mobile</span
            >
            <p class="text-gray-600 mb-2">
              2014 - 2015 à l'université Pierre et Marie Curie à Paris
            </p>
          </div>
          <div class="p-6">
            <span class="text-blue-800 font-bold"
              >BTS SIO ( Services informatiques aux organisation )</span
            >
            <p class="text-gray-600 mb-2">
              2011 - 2014 au lycée Léonard de Vinci à Melun
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
